'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _BaseIcon2 = require('./BaseIcon');

var _BaseIcon3 = _interopRequireDefault(_BaseIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Signout = function (_BaseIcon) {
  (0, _inherits3.default)(Signout, _BaseIcon);

  function Signout() {
    (0, _classCallCheck3.default)(this, Signout);
    return (0, _possibleConstructorReturn3.default)(this, (Signout.__proto__ || (0, _getPrototypeOf2.default)(Signout)).apply(this, arguments));
  }

  (0, _createClass3.default)(Signout, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        this.getSvgProps(),
        _react2.default.createElement('path', (0, _extends3.default)({ d: 'M1 11.6643033L11.0790137 5v4.00835196s11.6229315.8766327 11.6229315 9.32143894c0 0-1.4703836-3.4659706-7.0933425-4.1229271-.9200822-.1074696-2.3175342-.2128669-4.5329041-.2128669v4.3346098L1 11.6643033z'
        }, this.getPathProps()))
      );
    }
  }]);
  return Signout;
}(_BaseIcon3.default);
/*eslint-enable */


Signout.defaultProps = {
  width: 22,
  height: 14,
  viewBox: '1 5 22 14'
};
exports.default = Signout;
//# sourceMappingURL=Signout.js.map


//////////////////
// WEBPACK FOOTER
// ../icon/lib/Icons/Signout.js
// module id = 321
// module chunks = 0